var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgU1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 32,
    viewBox: "0 0 102 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 31C1 31 11.0159 25.375 14.75 25.375C18.4841 25.375 22.3603 28.1317 26 25.3796C29.6397 22.6275 30.3912 19.7395 33.5 21.625C36.6088 23.5105 39.5851 23.5105 41 21.625C42.4149 19.7395 41.0372 18.8125 46 18.8125C50.9628 18.8125 50.5215 13.5116 52.25 10.375C53.9785 7.23842 56.5262 3.97844 61 6.625C65.4738 9.27156 68.5213 7.52644 69.75 5.6875C70.9787 3.84856 72.0027 2.875 74.75 2.875C77.4973 2.875 77.472 4.75 79.75 4.75C82.028 4.75 82.7494 6.625 86 6.625C89.2506 6.625 91.0932 1.93986 93.5 1.93986C95.9068 1.93986 101 1 101 1V31H1Z",
    fill: "url(#paint0_linear_1295_1056)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 31C1 31 11.0159 25.375 14.75 25.375C18.4841 25.375 22.3603 28.1317 26 25.3796C29.6397 22.6275 30.3912 19.7395 33.5 21.625C36.6088 23.5105 39.5851 23.5105 41 21.625C42.4149 19.7395 41.0372 18.8125 46 18.8125C50.9628 18.8125 50.5215 13.5116 52.25 10.375C53.9785 7.23842 56.5262 3.97844 61 6.625C65.4738 9.27156 68.5213 7.52644 69.75 5.6875C70.9787 3.84856 72.0027 2.875 74.75 2.875C77.4973 2.875 77.472 4.75 79.75 4.75C82.028 4.75 82.7494 6.625 86 6.625C89.2506 6.625 91.0932 1.93986 93.5 1.93986C95.9068 1.93986 101 1 101 1",
    stroke: "#42A93C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1295_1056",
    x1: 1.21281,
    y1: 1,
    x2: 1.21281,
    y2: 30.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42A93C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42A93C",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU1);
export default __webpack_public_path__ + "static/media/U1.c6595359bd8d2919a320d0ac10a82b37.svg";
export { ForwardRef as ReactComponent };